import { Link } from "react-router-dom";
import { Shield, CreditCard, User, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/core/auth/auth";

export function PortalAccount() {
  const { user } = useAuth();

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Account</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage profile access, compliance settings, and subscription links.
        </p>
      </div>

      <div className="rounded-lg border border-border/50 p-4 bg-background/60">
        <div className="flex items-center gap-2 text-sm font-medium"><User className="h-4 w-4" /> Signed In</div>
        <div className="text-sm text-muted-foreground mt-2">{user?.email ?? "Unknown user"}</div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="rounded-lg border border-border/50 p-4">
          <div className="flex items-center gap-2 text-sm font-medium"><Shield className="h-4 w-4" /> Security</div>
          <p className="text-xs text-muted-foreground mt-2">Password, access, and account safeguards.</p>
          <Button asChild variant="outline" size="sm" className="mt-3">
            <Link to="/settings/security">Open Security</Link>
          </Button>
        </div>

        <div className="rounded-lg border border-border/50 p-4">
          <div className="flex items-center gap-2 text-sm font-medium"><CreditCard className="h-4 w-4" /> Billing</div>
          <p className="text-xs text-muted-foreground mt-2">Subscription plan and payment details.</p>
          <Button asChild variant="outline" size="sm" className="mt-3">
            <Link to="/portal/billing">Open Billing</Link>
          </Button>
        </div>

        <div className="rounded-lg border border-border/50 p-4">
          <div className="flex items-center gap-2 text-sm font-medium"><LifeBuoy className="h-4 w-4" /> Support</div>
          <p className="text-xs text-muted-foreground mt-2">Need help with setup or workflow tuning.</p>
          <Button asChild variant="outline" size="sm" className="mt-3">
            <a href="mailto:support@radiologylive.ai">Contact Support</a>
          </Button>
        </div>
      </div>
    </div>
  );
}
